import React, { useEffect, useState } from "react";
import {
  Divider,
  Flex,
  Layout,
  Menu,
  Drawer,
  Button,
  Typography,
  Modal,
} from "antd";
import { MenuOutlined, CloseCircleOutlined } from "@ant-design/icons";
import plates from "../../Images/Plates.svg";
import styled from "styled-components";
import NewDashboardPage from "../NewDashboardPage/NewDashboardPage";
import NewDailyPlanningPage from "../NewDailyPlanningPage/NewDailyPlanningPage";
import NewOpeningHoursPage from "../NewOpeningHoursPage/NewOpeningHoursPage";
import NewFullMenuManagementPage from "../NewFullMenuManagementPage/NewFullMenuManagementPage";
import NewFeatureManagementPage from "../NewFeatureManagementPage/NewFeatureManagementPage";
import NewRestaurantProfilePage from "../NewRestaurantProfilePage/NewRestaurantProfilePage";
import Plates from "../../Components/SVGs/Plates";
import { useNavigate } from "react-router-dom";
import NewMenuManagementPage from "../NewMenuManagementPage/NewMenuManagementPage";
const { Sider } = Layout;
const Logo = require("./../../Images/Logo.png");

export default function LayoutRestaurantsPages() {
  const [collapsed, setCollapsed] = React.useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const [activePage, setActivePage] = useState("Inicio");
  const navigate = useNavigate();
  const onCollapse = () => {
    setCollapsed(!collapsed);
  };
  const changePage = ({ key }) => {
    setActivePage(key);
  };
  const renderPage = () => {
    switch (activePage) {
      case "NewDashboardPage":
        return <NewDashboardPage />;
      case "NewDailyPlanningPage":
        return <NewDailyPlanningPage />;
      case "NewOpeningHoursPage":
        return <NewOpeningHoursPage />;
      case "NewMenuManagementPage":
        return <NewMenuManagementPage isMobile={isMobile} />;
      case "NewFullMenuManagementPage":
        return <NewFullMenuManagementPage isMobile={isMobile} />;
      case "NewFeatureManagementPage":
        return <NewFeatureManagementPage />;
      case "NewRestaurantProfilePage":
        return <NewRestaurantProfilePage isMobile={isMobile} />;
      default:
        return <NewDashboardPage />;
    }
  };

  const [drawerVisible, setDrawerVisible] = useState(false);

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const onClose = () => {
    setDrawerVisible(false);
  };

  useEffect(() => {
    const userData = localStorage.getItem("userData");
    if (userData) {
      navigate("/home");
    }
  }, []);
  useEffect(() => {
    const mobileUserAgents = [
      "Android",
      "webOS",
      "iPhone",
      "iPad",
      "iPod",
      "BlackBerry",
      "Windows Phone",
    ];
    const userAgent = navigator.userAgent;
    const isMobileDevice = mobileUserAgents.some((mobileAgent) =>
      userAgent.includes(mobileAgent)
    );
    setIsMobile(isMobileDevice);
  }, []);

  const StyledMenuItem = styled(Menu.Item)`
    display: flex;
    align-items: center;
    justify-content: center;
  `;

  const StyledHorizontalMenu = styled(Menu)`
    display: flex;
    width: 100vw;
    max-width: 100vw;
    height: 10%;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: sticky;
    background-color: white;

    svg {
      fill: #333;
    }
  `;
  return (
    <Layout style={{ minHeight: "100vh" }}>
      {!isMobile && (
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={onCollapse}
          style={{
            background: "white",
          }}
          width={256}
        >
          <Flex align="center" justify="center">
            <img
              src={Logo}
              alt="Logo"
              style={{
                width: 80,
                marginTop: 10,
                height: "auto",
                justifySelf: "center",
                alignSelf: "center",
                margin: "auto",
              }}
            />
          </Flex>
          <Divider style={{ margin: "12px 0" }} />
          <Menu
            theme="light"
            mode="inline"
            onClick={changePage}
            selectedKeys={[activePage]}
          >
            <Menu.Item
              key="NewDashboardPage"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-dashboard"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="2.5"
                  stroke="orange"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M12 13m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                  <path d="M13.45 12.55l2.05 -2.05" />
                  <path d="M6.4 20a9 9 0 1 1 11.2 0z" />
                </svg>
              }
            >
              Dashboard
            </Menu.Item>
            <Menu.Item
              key="NewDailyPlanningPage"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-calendar-month"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="2.5"
                  stroke="orange"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" />
                  <path d="M16 3v4" />
                  <path d="M8 3v4" />
                  <path d="M4 11h16" />
                  <path d="M7 14h.013" />
                  <path d="M10.01 14h.005" />
                  <path d="M13.01 14h.005" />
                  <path d="M16.015 14h.005" />
                  <path d="M13.015 17h.005" />
                  <path d="M7.01 17h.005" />
                  <path d="M10.01 17h.005" />
                </svg>
              }
            >
              Planeamento de diárias
            </Menu.Item>
            <Menu.Item
              key="NewOpeningHoursPage"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-clock-hour-3"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="2.5"
                  stroke="orange"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                  <path d="M12 12h2.5" />
                  <path d="M12 7v5" />
                </svg>
              }
            >
              Horário de funcionamento
            </Menu.Item>
            <Menu.Item
              key="NewMenuManagementPage"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-list"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="2.5"
                  stroke="orange"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M9 6l11 0" />
                  <path d="M9 12l11 0" />
                  <path d="M9 18l11 0" />
                  <path d="M5 6l0 .01" />
                  <path d="M5 12l0 .01" />
                  <path d="M5 18l0 .01" />
                </svg>
              }
            >
              Pratos do dia
            </Menu.Item>
            <Menu.Item
              key="NewFullMenuManagementPage"
              icon={
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.05 10.96H8.93C8.51579 10.96 8.18 10.6242 8.18 10.21C8.18 9.79579 8.51579 9.46 8.93 9.46H12.05C12.4642 9.46 12.8 9.79579 12.8 10.21C12.8 10.6242 12.4642 10.96 12.05 10.96Z"
                    fill="orange"
                  />
                  <path
                    d="M8.93 12.57H15.07C15.4842 12.57 15.82 12.9058 15.82 13.32C15.82 13.7342 15.4842 14.07 15.07 14.07H8.93C8.51579 14.07 8.18 13.7342 8.18 13.32C8.18 12.9058 8.51579 12.57 8.93 12.57Z"
                    fill="orange"
                  />
                  <path
                    d="M14.23 15.5H8.93C8.51579 15.5 8.18 15.8358 8.18 16.25C8.18 16.6642 8.51579 17 8.93 17H14.23C14.6442 17 14.98 16.6642 14.98 16.25C14.98 15.8358 14.6442 15.5 14.23 15.5Z"
                    fill="orange"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14.27 2C15.0792 1.99888 15.7474 2.63193 15.79 3.44C18.1649 3.70703 19.9696 5.70032 20 8.09V18.18C19.9945 20.8011 17.8711 22.9245 15.25 22.93H8.75C6.12893 22.9245 4.0055 20.8011 4 18.18V8.09C4.03041 5.70032 5.83508 3.70703 8.21 3.44C8.25747 2.63419 8.9228 2.00388 9.73 2H14.27ZM14.29 3.44H9.73V4.63H14.29V3.44ZM18.5 18.18C18.5 19.9766 17.0465 21.4345 15.25 21.44H8.75C6.95345 21.4345 5.49999 19.9766 5.5 18.18V8.09C5.50398 6.49887 6.65936 5.14458 8.23 4.89C8.35276 5.62136 8.98843 6.15532 9.73 6.15H14.27C15.0116 6.15532 15.6472 5.62136 15.77 4.89C17.3406 5.14458 18.496 6.49887 18.5 8.09V18.18Z"
                    fill="orange"
                  />
                </svg>
              }
            >
              Menu completo
            </Menu.Item>
            <Menu.Item
              key="NewFeatureManagementPage"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-settings"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="2.5"
                  stroke="orange"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c2.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 2.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-2.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -2.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
                  <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                </svg>
              }
            >
              Gestão de características
            </Menu.Item>{" "}
            <Menu.Item
              key="NewRestaurantProfilePage"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-user-check"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="2.5"
                  stroke="orange"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
                  <path d="M6 21v-2a4 4 0 0 1 4 -4h4" />
                  <path d="M15 19l2 2l4 -4" />
                </svg>
              }
            >
              Perfil do restaurante
            </Menu.Item>
            <Menu.Item
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-logout"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="2.5"
                  stroke="orange"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
                  <path d="M9 12h12l-3 -3" />
                  <path d="M18 15l3 -3" />
                </svg>
              }
              onClick={() => {
                Modal.confirm({
                  title: "Terminar sessão atual",
                  content: "Deseja sair da conta?",
                  onOk() {
                    localStorage.removeItem("userData");
                    navigate("/");
                  },
                });
              }}
            >
              Terminal sessão
            </Menu.Item>
          </Menu>
        </Sider>
      )}
      <Layout>
        <Layout.Content>
          <div>
            {isMobile && (
              <Flex
                align="center"
                justify="space-between"
                style={{
                  width: "90vw",
                  margin: "1rem auto",
                  justifySelf: "center",
                  height: "10%",
                  overflow: "hidden",
                  alignSelf: "center",
                }}
              >
                <img
                  src={Logo}
                  alt="Logo"
                  style={{ width: "40px", height: "40px" }}
                />
                <h1
                  style={{
                    color: "#F36527",
                    fontFamily: "var(--body-body-1-font-family)",
                  }}
                >
                  TelaBite
                </h1>
                <Flex>
                  <Button
                    type="primary"
                    onClick={showDrawer}
                    icon={<MenuOutlined />}
                    style={{
                      backgroundColor: "#F36527",
                    }}
                  />
                  <Drawer
                    placement="left"
                    closeIcon={
                      <Button
                        type="link"
                        onClick={onClose}
                        icon={<CloseCircleOutlined />}
                        hoverable={true}
                        mouseEnter={(e) =>
                          (e.currentTarget.style.color = "#fa8c16")
                        }
                        mouseLeave={(e) => (e.currentTarget.style.color = "")}
                      />
                    }
                    closable={false}
                    onClose={onClose}
                    visible={drawerVisible}
                  >
                    <Flex align="center" justify="center">
                      <img
                        src={Logo}
                        alt="Logo"
                        style={{
                          width: "40%",
                          height: "auto",
                          justifySelf: "center",
                          alignSelf: "center",
                          margin: "auto",
                          marginBottom: "10vh",
                        }}
                      />
                    </Flex>
                    <Divider />
                    <Menu selectedKeys={[activePage]}>
                      <StyledMenuItem
                        key="NewDashboardPage"
                        onClick={() => {
                          changePage({ key: "NewDashboardPage" });
                          onClose();
                        }}
                        icon={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon icon-tabler icon-tabler-dashboard"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            stroke-width="2.5"
                            stroke="orange"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M12 13m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                            <path d="M13.45 12.55l2.05 -2.05" />
                            <path d="M6.4 20a9 9 0 1 1 11.2 0z" />
                          </svg>
                        }
                      >
                        Dashboard
                      </StyledMenuItem>
                      <StyledMenuItem
                        key="NewDailyPlanningPage"
                        onClick={() => {
                          changePage({ key: "NewDailyPlanningPage" });
                          onClose();
                        }}
                        icon={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon icon-tabler icon-tabler-calendar-month"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            stroke-width="2.5"
                            stroke="orange"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" />
                            <path d="M16 3v4" />
                            <path d="M8 3v4" />
                            <path d="M4 11h16" />
                            <path d="M7 14h.013" />
                            <path d="M10.01 14h.005" />
                            <path d="M13.01 14h.005" />
                            <path d="M16.015 14h.005" />
                            <path d="M13.015 17h.005" />
                            <path d="M7.01 17h.005" />
                            <path d="M10.01 17h.005" />
                          </svg>
                        }
                      >
                        Planeamento de diárias
                      </StyledMenuItem>
                      <StyledMenuItem
                        key="NewOpeningHoursPage"
                        onClick={() => {
                          changePage({ key: "NewOpeningHoursPage" });
                          onClose();
                        }}
                        icon={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon icon-tabler icon-tabler-clock-hour-3"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            stroke-width="2.5"
                            stroke="orange"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                            <path d="M12 12h2.5" />
                            <path d="M12 7v5" />
                          </svg>
                        }
                      >
                        Horário de funcionamento
                      </StyledMenuItem>
                      <StyledMenuItem
                        key="NewMenuManagementPage"
                        onClick={() => {
                          changePage({ key: "NewMenuManagementPage" });
                          onClose();
                        }}
                        icon={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon icon-tabler icon-tabler-list"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            stroke-width="2.5"
                            stroke="orange"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M9 6l11 0" />
                            <path d="M9 12l11 0" />
                            <path d="M9 18l11 0" />
                            <path d="M5 6l0 .01" />
                            <path d="M5 12l0 .01" />
                            <path d="M5 18l0 .01" />
                          </svg>
                        }
                      >
                        Pratos do dia
                      </StyledMenuItem>
                      <StyledMenuItem
                        key="NewFullMenuManagementPage"
                        onClick={() => {
                          changePage({ key: "NewFullMenuManagementPage" });
                          onClose();
                        }}
                        icon={
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.05 10.96H8.93C8.51579 10.96 8.18 10.6242 8.18 10.21C8.18 9.79579 8.51579 9.46 8.93 9.46H12.05C12.4642 9.46 12.8 9.79579 12.8 10.21C12.8 10.6242 12.4642 10.96 12.05 10.96Z"
                              fill="orange"
                            />
                            <path
                              d="M8.93 12.57H15.07C15.4842 12.57 15.82 12.9058 15.82 13.32C15.82 13.7342 15.4842 14.07 15.07 14.07H8.93C8.51579 14.07 8.18 13.7342 8.18 13.32C8.18 12.9058 8.51579 12.57 8.93 12.57Z"
                              fill="orange"
                            />
                            <path
                              d="M14.23 15.5H8.93C8.51579 15.5 8.18 15.8358 8.18 16.25C8.18 16.6642 8.51579 17 8.93 17H14.23C14.6442 17 14.98 16.6642 14.98 16.25C14.98 15.8358 14.6442 15.5 14.23 15.5Z"
                              fill="orange"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M14.27 2C15.0792 1.99888 15.7474 2.63193 15.79 3.44C18.1649 3.70703 19.9696 5.70032 20 8.09V18.18C19.9945 20.8011 17.8711 22.9245 15.25 22.93H8.75C6.12893 22.9245 4.0055 20.8011 4 18.18V8.09C4.03041 5.70032 5.83508 3.70703 8.21 3.44C8.25747 2.63419 8.9228 2.00388 9.73 2H14.27ZM14.29 3.44H9.73V4.63H14.29V3.44ZM18.5 18.18C18.5 19.9766 17.0465 21.4345 15.25 21.44H8.75C6.95345 21.4345 5.49999 19.9766 5.5 18.18V8.09C5.50398 6.49887 6.65936 5.14458 8.23 4.89C8.35276 5.62136 8.98843 6.15532 9.73 6.15H14.27C15.0116 6.15532 15.6472 5.62136 15.77 4.89C17.3406 5.14458 18.496 6.49887 18.5 8.09V18.18Z"
                              fill="orange"
                            />
                          </svg>
                        }
                      >
                        Menu completo
                      </StyledMenuItem>
                      <StyledMenuItem
                        key="NewFeatureManagementPage"
                        onClick={() => {
                          changePage({ key: "NewFeatureManagementPage" });
                          onClose();
                        }}
                        icon={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon icon-tabler icon-tabler-settings"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            stroke-width="2.5"
                            stroke="orange"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c2.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 2.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-2.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -2.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
                            <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                          </svg>
                        }
                      >
                        Gestão de características
                      </StyledMenuItem>{" "}
                      <StyledMenuItem
                        key="NewRestaurantProfilePage"
                        onClick={() => {
                          changePage({ key: "NewRestaurantProfilePage" });
                          onClose();
                        }}
                        icon={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon icon-tabler icon-tabler-user-check"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            stroke-width="2.5"
                            stroke="orange"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
                            <path d="M6 21v-2a4 4 0 0 1 4 -4h4" />
                            <path d="M15 19l2 2l4 -4" />
                          </svg>
                        }
                      >
                        Perfil do restaurante
                      </StyledMenuItem>
                      <StyledMenuItem
                        icon={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon icon-tabler icon-tabler-logout"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            stroke-width="2.5"
                            stroke="orange"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
                            <path d="M9 12h12l-3 -3" />
                            <path d="M18 15l3 -3" />
                          </svg>
                        }
                        onClick={() => {
                          Modal.confirm({
                            title: "Terminar sessão atual",
                            content: "Deseja sair da conta?",
                            onOk() {
                              localStorage.removeItem("userData");
                              navigate("/");
                            },
                          });
                        }}
                      >
                        Terminal sessão
                      </StyledMenuItem>
                    </Menu>
                  </Drawer>
                </Flex>
              </Flex>
            )}
            {renderPage()}
          </div>
        </Layout.Content>
      </Layout>
    </Layout>
  );
}
